<template>
    <div>
        <Wp_nav_bar title="技术支持"></Wp_nav_bar>
        <div style=" border-radius: 5px; box-shadow: 0px 1px 3px #aaaaaa; margin: 16px">
            <Wp_image url="https://cdn.quasar.dev/img/mountains.jpg" radius="5px 5px 0px 0px"></Wp_image>
            <div style="padding: 16px">
                <div style="font-size: 20px">技术支持</div>

                <div style="padding-top: 16px">
                    <span v-html="content" style="white-space: pre-wrap; font-size: 14px"/>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_image from "../custom/Wp_image";

    export default {
        name: "Support",
        components: {Wp_image, Wp_nav_bar},
        data() {
            return {
                content:
                    "邮箱: 19933226@qq.com",
            };
        },
    };
</script>

<style scoped>
</style>